import PasswordChangePage from "./PasswordChangePage";
export default PasswordChangePage;